module.exports = __webpack_public_path__ + "static/media/sound1.5d1a7c95.mp3";